(function($) {
	if($( ".calc-sq-meter" ).length){

		var unit_price 		= $( '#unit-price' ).val();
		var unit_minimum 	= $( '#unit-minimum' ).val();
		var unit_max 		= $( '#unit-max' ).val();
		var add_to_cart		= $( 'form.cart' );
		var alert_html		= $( '.turf-calculator__alerts' );

		// switcher between delivery and collection
		$('.turf-calculator__method input').on('change', function() {
			var method = $('.turf-calculator input[name=method]:checked').val();

			if( method === 'collection' ) {
				$('.turf-calculator__input_postcode').hide();
			} else {
				$('.turf-calculator__input_postcode').show();
			}
		});

		$( ".calc-sq-meter" ).click(function() {
			var amount_input 		= $( "#calc-sq-meter-quantity" ).val();
			var width_input 		= $( "#calc-sq-meter-width" ).val();
			var length_input 		= $( "#calc-sq-meter-length" ).val();
			var calculation_select	= $( 'input[name="type-calculate"]:checked' ).val();
			var total_m2_output 	= $( "#calc-sq-meter-total-m2" );
			var total_output 		= $( "#calc-sq-meter-total" );
			var total_delivery 		= $( "#calc-delivery" );
			var product_quantity 	= $( ".input-text.qty" );
			var total				= 0;
			var total_m2			= 0;
			var error 				= false;
			var error_message 		= false;
			var postcode			= null;

			if(amount_input > 0){
				total_m2 	=  amount_input;
				total_m2 	=  Math.round(total_m2);
				total 		=  unit_price * total_m2;
			} else {
				error = true;
				error_message = 'Invalid value(s) entered';
			}

			if( $('.turf-calculator input[name=method]:checked').val() === 'delivery' ){
				postcode = $("#calc-sq-meter-m2-postcode").val();
				var postcode_regex = /^[A-Z]{1,2}[0-9]{1,2} ?[0-9][A-Z]{2}$/i;

				if (!postcode_regex.test(postcode)) {
					error = true;
					error_message = 'Please enter valid postcode';
				} else {
					if (!postcode.includes(" ")) {
						postcode = postcode.replace(/^(.*)(\d)/, "$1 $2");
					}
					$("#calc-sq-meter-m2-postcode").val(postcode);
				}
			}

			if(!error){

				if( $('.turf-calculator input[name=method]:checked').val() === 'delivery' ){
					if(total_m2 >= 30 && total_m2 <= 300){
						$.ajax({
							method: "POST",
							url: "/wp-json/delivery/v1/calculate",
							data: { postcode: postcode, qty: total_m2 }
						}).done(function( data ) {
							var response = jQuery.parseJSON(data );

							if (response.result == "success") {

								total_m2_output.html(total_m2);

								var delivery_cost = Number(response.message.cost);
								total_delivery.html('£' + delivery_cost.toFixed(2));

								total = total + delivery_cost;
								total = total.toFixed(2);

								total_output.html('£' + total);
								product_quantity.val(total_m2);

								$('.basket-trigger').attr('disabled', false);
								alert_html.fadeOut();

								// set cookie
								Cookies.set('postcode', postcode);

							} else {
								alert_html.html(response.message);
								alert_html.fadeIn();
								$('.basket-trigger').attr('disabled', true);

								total_delivery.html('--');
								total_output.html('--');
							}
						});
					} else if(total_m2 < 30) {
						error = true;
						error_message = 'Unfortunately, the minimum order amount required for delivery is ' + unit_minimum + 'm² please increase the amount you wish to purchase';
					} else if(total_m2 > 300) {
						error = true;
						error_message = 'Unfortunately, the maximum order amount available online is ' + unit_max + 'm². If you wish to order a larger amount please <a href="/contact-us/">contact us</a> directly.';
					}
				} else {
					Cookies.remove('postcode');

					if(total_m2 >= 1 && total_m2 <= 300){
						total_m2_output.html(total_m2);
						total_delivery.html('FREE');

						total_output.html('£' + total);
						product_quantity.val(total_m2);

						$('.basket-trigger').attr('disabled', false);
						alert_html.fadeOut();
					} else if(total_m2 < 1) {
						error = true;
						error_message = 'Unfortunately, the minimum order amount required for collection is 1m² please increase the amount you wish to purchase';
					} else if(total_m2 > 300) {
						error = true;
						error_message = 'Unfortunately, the maximum order amount available to order is ' + unit_max + 'm². If you wish to order a larger amount please <a href="/contact-us/">contact us</a> directly.';
					}
				}
				$('.turf-calculator__output').addClass('active');
			}

			if(error){
				alert_html.html(error_message);
				alert_html.fadeIn();
				$('.basket-trigger').attr('disabled', true);
				total_m2_output.html(total_m2);
				total_output.html('--');
			}
		});

		$( '.basket-trigger' ).click(function(e) {
			// fake click add to cart
			e.preventDefault();
			$('.single_add_to_cart_btn').click();
		});

		$( 'input[name="type-calculate"]' ).click(function() {
			var calculation_select	= $( 'input[name="type-calculate"]:checked' ).val();
			var amount_ready_fields	= $( '.turf-calculator__amount-ready' );
			var calculation_fields	= $( '.turf-calculator__calculate' );
			$( "#calc-sq-meter-total-m2").html('--');
			$( "#calc-sq-meter-total").html('--');
			$( "#calc-sq-meter-quantity").val(0);
			$( "#calc-sq-meter-width").val(0);
			$( "#calc-sq-meter-length").val(0);

			if(calculation_select == 'amount-ready'){
				$( ".calc-sq-meter" ).html('Confirm quantity');
				calculation_fields.hide();
				amount_ready_fields.show();
				$('.basket-trigger').attr('disabled', true);
			} else if(calculation_select == "calculate"){
				$( ".calc-sq-meter" ).html('Calculate');
				amount_ready_fields.hide();
				calculation_fields.show();
				$('.basket-trigger').attr('disabled', true);
			}
		});

		$( '.calculator-option' ).click(function() {
			if(!$(this).hasClass('active')){
				$( '.calculator-option.active' ).removeClass('active');
				$(this).addClass('active');
			}
		});
	}

	$( '.gf-cate-filter li' ).click(function() {
		$( '.gf-cate-filter li.active' ).removeClass('active');
		$(this).addClass('active');
	});

	$( '.telephone-dropdown' ).click(function() {
		$(this).toggleClass('active');
	});

})(jQuery);
